import { useEffect, useState } from "react";
import axios from "axios";
import { Bot, X, ArrowRight } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function DailyBriefingBanner({ token, onOpen }) {
  const [briefing, setBriefing] = useState(null);
  const [hidden, setHidden] = useState(false);
  const today = new Date().toISOString().slice(0, 10);

  useEffect(() => {
    if (localStorage.getItem("ah_briefing_dismissed") === today) { setHidden(true); return; }
    axios.get(`${API}/assistant/briefing`, { headers: { Authorization: `Bearer ${token}` } })
      .then((r) => setBriefing(r.data)).catch(() => {});
    // eslint-disable-next-line
  }, [token]);

  if (hidden || !briefing?.summary) return null;
  const urgent = briefing.sections?.filter((s) => s.count > 0).slice(0, 4) || [];

  return (
    <div className="mb-5 bg-gradient-to-r from-[#F2B705]/15 via-[#0C0C0C] to-[#0C0C0C] border border-[#F2B705]/30 rounded-xl p-4" data-testid="daily-briefing-banner">
      <div className="flex items-start gap-3">
        <div className="h-9 w-9 rounded-full bg-[#F2B705]/20 flex items-center justify-center shrink-0"><Bot size={17} className="text-[#F2B705]" /></div>
        <div className="min-w-0 flex-1">
          <div className="text-[#F2B705] text-[11px] font-bold uppercase tracking-widest">Your AI daily briefing</div>
          <p className="text-white/80 text-sm mt-0.5 line-clamp-2">{briefing.summary}</p>
          <div className="flex flex-wrap gap-1.5 mt-2">
            {urgent.map((s) => (
              <span key={s.key} className="px-2 py-0.5 rounded-full bg-white/5 border border-white/10 text-white/55 text-[11px]">{s.label}: <b className="text-[#F2B705]">{s.count}</b></span>
            ))}
          </div>
        </div>
        <div className="flex items-center gap-2 shrink-0">
          <button data-testid="briefing-open-btn" onClick={onOpen}
            className="flex items-center gap-1.5 px-3.5 py-2 rounded-md bg-[#F2B705] text-black font-bold text-xs hover:bg-white transition-colors">
            Open AI Assistant <ArrowRight size={12} />
          </button>
          <button data-testid="briefing-dismiss" onClick={() => { localStorage.setItem("ah_briefing_dismissed", today); setHidden(true); }}
            className="text-white/35 hover:text-white"><X size={16} /></button>
        </div>
      </div>
    </div>
  );
}
